import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,ViewChild,ElementRef,EventEmitter } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

declare var daum: any;

import {
    DtgListType
} from "src/app/shared/vo";


@Component({
  templateUrl: "./modal.addr.search.component.html"
  ,styleUrls: ["./modal.addr.search.component.scss"]
})
export class ModalAddrSearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    listItem:any[];
    DtgListType = DtgListType;
    @Input() inAddr:string;
    // @Output() outAddr = new EventEmitter();
    @ViewChild("modalSearchAddrContent") modalSearchAddrContent: ElementRef;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private elementRef:ElementRef
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        console.log("ModalAddrSearchComponent",this.inAddr,this.modalSearchAddrContent.nativeElement);
        let self = this;
        // let elContent = this.modalSearchAddrContent.nativeElement;
        let elContent = this.elementRef.nativeElement.querySelector("#modal-search-addr-content");
        // modal-search-addr-content
        new daum.Postcode({
            oncomplete: function(data) {
                let addr = ''; // 주소 변수
                let extraAddr = ''; // 참고항목 변수
                
                //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                    addr = data.roadAddress;
                } else { // 사용자가 지번 주소를 선택했을 경우(J)
                    addr = data.jibunAddress;
                }
                // this.outAddr.emit(addr);
                self.clickSelectAddr(addr);
            }
            ,width : "100%"
            ,height : "100%"
            ,maxSuggestItems : 5
            ,alwaysShowEngAddr : false //영문주소 가리기
            ,zonecodeOnly : true //구형 우편번호 가리기
        }).embed(
            elContent
            ,{
                q : this.inAddr // 입력 주소 전달
            }
        );
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSelectAddr(addr:any){
        this.activeModal.close({
            "result":"ok"
            ,"addr":addr
        });
    }
}
